import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Thumbnail } from 'app/design/primitives/thumbnail';
import { type useSharingPlaceMembers } from 'app/network/sharing-place';
import { useTranslation } from 'react-i18next';
import { Pressable, View } from 'react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconChevronRight } from '@tabler/icons-react-native';
import { theme } from './shared';

export function PlaceMembersSummary({
  members,
  onOpen,
}: {
  members: NonNullable<ReturnType<typeof useSharingPlaceMembers>['data']>;
  onOpen: () => void;
}) {
  const { t } = useTranslation();
  if (members.length === 0) return null;
  return (
    <Pressable onPress={onOpen}>
      <Row alignItems="center" style={{ gap: 28 }}>
        <Row style={{ alignItems: 'center' }}>
          {members.slice(0, 3).map((member, index) => (
            <View
              key={member.id}
              style={{
                marginLeft: index === 0 ? 0 : -theme.spacing['spacing.general.x1'],
                borderRadius: 14,
                borderWidth: 1,
                borderColor: theme.colors['surface.default'],
              }}
            >
              <Thumbnail height={28} width={28} source={{ uri: member.user?.profile?.picture }} />
            </View>
          ))}
          {members.length > 3 ? (
            <View
              style={{
                borderRadius: 14,
                marginLeft: -theme.spacing['spacing.general.x1'],
                borderWidth: 1,
                borderColor: theme.colors['surface.default'],
                backgroundColor: theme.colors['surface.tertiary'],
                justifyContent: 'center',
                alignItems: 'center',
                width: 28,
                height: 28,
              }}
            >
              <Text color="text.primary" fontSize={14} lineHeight={28} textAlign="center">
                +
              </Text>
            </View>
          ) : null}
          <Text
            color="text.primary"
            variant="bodyBase"
            marginLeft="spacing.general.x2"
            style={{ textDecorationLine: 'underline', color: theme.colors['text.secondary'] }}
          >
            {t('place.members', { count: members.length, ns: 'neighbour-profile' })}
          </Text>
          <IconChevronRight strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['surface.brand.default']} size={20} />
        </Row>
      </Row>
    </Pressable>
  );
}
